import PropTypes from 'prop-types';
import { Outlet } from 'react-router-dom';
import ReceptorNav from '../solicitudes/ReceptorNav.jsx';
import './PerfilLayout.css';

export default function PerfilLayout({ children, preview = false }) {
  return (
    <div className="pf-shell receptor-shell">
      <div className="pf-main receptor-main">{children ?? <Outlet />}</div>
      <ReceptorNav preview={preview} />
    </div>
  );
}

PerfilLayout.propTypes = {
  children: PropTypes.node,
  preview: PropTypes.bool,
};
